// 请求模块
import axios from 'axios'
import router from '../router'
import store from '@/store'
// 如果使用创建实例的话axios都要改成request
const request = axios.create({
// 接口的基准路径
  baseURL: process.env.VUE_APP_BASE_API
})

// 请求拦截器
request.interceptors.request.use(config => {
  // console.log(config.url)
  store.commit('showLoading')
  if(store.state.userInfo.token){
    config.headers = {
      token: store.state.userInfo.token || ''
    }
  }
  return config
}, error => {
  store.commit('hideLoading')
  return Promise.reject(error)
})

// 响应拦截器
request.interceptors.response.use(res => {
  const code = res.data.code
  if (code === 401) {
    // token 失效
    router.push('/loading')
  }
  store.commit('hideLoading')
  return res.data
}, error => {
  store.commit('hideLoading')
  return Promise.reject(error)
})

export default request
